<section
  id="team"
  class="team services p-4 md:p-8 m-4 md:m-8"
  style="border-radius: 30px;"
>
  <div class="pb-8 md:pb-6">
    <h2 class="font-clashg text-lg text-center mt-4 uppercase font-bold text-DarkBlue">
      Nuestro Equipo
    </h2>

    <!-- Ajuste de imágenes para dispositivos móviles -->
    <div
      class="flex flex-col md:flex-row space-y-4 md:space-y-0 mt-6 justify-center"
    >
      <div class="flex justify-start items-start space-x-2">
        <img src="/Team/tecnicos.svg" alt="Nuestro Equipo" class="h-auto w-16" />
        <div class="flex flex-col w-8/12">
          <h3 class="font-clashg mt-2 font-medium text-left text-xl sm:text2xl mb-2">Técnicos y Licenciados</h3>
          <p class="text-sm text-Gray">
            Matriculados en el Colegio de Técnicos y Licenciados de San Juan, con amplia experiencia en proyectos industriales.
          </p>
        </div>
      </div>
      <div class="flex justify-start items-start space-x-2">
        <img src="/Team/ingenieros.svg" alt="Nuestro Equipo" class="h-auto w-16" />
        <div class="flex flex-col w-8/12">
          <h3 class="font-clashg mt-2 font-medium text-left text-lg md:text-2xl mb-2">Ingenieros Especialistas</h3>
          <p class="text-sm text-Gray">
            Registrados en el Consejo Profesional de Ingenieros y Agrimensores de San Juan, supervisando los proyectos más complejos.
          </p>
        </div>
      </div>
      <div class="flex justify-start items-start space-x-2">
        <img src="/Team/auditores.svg" alt="Nuestro Equipo" class="h-auto w-16" />
        <div class="flex flex-col w-8/12">
          <h3 class="font-clashg mt-2 font-medium text-left text-lg md:text-2xl mb-2">Auditores</h3>
          <p class="text-sm text-Gray">
            Expertos en la implementación de sistemas de gestión ambiental.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
